import React, { useState } from 'react';
import {
    ProcedureDataTitle,
    MainContainerItems,
    Subtitle,
    Div,
    Title,
    BackorderText,
    HeadContainer,
    TimeDiv,
} from './ProcedureData.styled';
import {
    HeaderData,
    DemiText,
} from 'src/common/refactoredComponents/dataTable/DataTable.styled';
import Datatable from 'src/common/refactoredComponents/dataTable/DataTable';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { isMobileDevice } from 'src/utils/util';
import { useDispatch } from 'react-redux';
import {
    setReportProcedureModalState,
    setOrderSummaryModalState,
} from 'src/pages/orders/redux/actions';
import { useSelector } from 'react-redux';
import { changeDateFormat, formatAMPM } from 'src/utils/dateUtils';
import ProcedureDataMobileView from './ProcedureDataMobileView';
import {
    getProcedureInfoRequest,
    resetLevelData,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { getTimeZoneName } from 'src/utils/dateUtils';
import { useTranslation } from 'react-i18next';
import { getConfigurations, setPediatricCheck } from 'src/common/redux/actions';
import {EQUITY, REPORT_PROCEDURE_DATA } from 'src/constants/appConstants';

const ProcedureData = ({ ordersList }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const procedureEquityPageVisibility = useSelector(
        (state) => state.loginReducer?.procedureEquityPageVisibility
    );
    const { salesOrg } = useSelector((state) => ({
        salesOrg: state.loginReducer.salesOrg,
    }));
    const { myCaseRef, procedureData } = useSelector((state) => ({
        myCaseRef: state.orderSummaryReducer.myCaseRef,
        procedureData: state.orderSummaryReducer?.reportProcedureData,
    }));
    const isMobile = isMobileDevice();
    const [procedureDateLocal, setProcedureData] = useState(() =>
        procedureData?.map((x) => ({ ...x, openCard: true }))
    );

    let colData = [
        {
            field: 'submitted',
        },
        {
            field: 'physician',
        },
        {
            field: 'procedureDetails',
        },

        {
            field: 'biologicsUsed',
        },
    ];

    colData = colData?.map((column) => {
        const extraProps = {
            bodyStyle: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        };
        switch (column.field) {
            case 'submitted':
                extraProps.header = (
                    <HeaderData>
                        <DemiText>{t('orders.priceOverrideHistoryStatus.submitted')}</DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: '15px 0px 11px 17px',
                    width: '25%',
                };
                extraProps.bodyStyle = {
                    padding: '10px 0px 0px 17px',
                    width: '25%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems width={'100%'}>
                            {rowData?.creationDateTime ? (
                                <div>
                                    {rowData?.creationDateTime ? (
                                        <Title>
                                            {changeDateFormat(
                                                rowData.creationDateTime
                                            )}
                                            <br />{' '}
                                            <TimeDiv>
                                                {formatAMPM(
                                                    rowData.creationDateTime
                                                )}{' '}
                                                {`${getTimeZoneName()} ${t('orders.orderDetails.billingSummary.by')} `}
                                                {rowData.createdBy}
                                            </TimeDiv>
                                        </Title>
                                    ) : null}
                                </div>
                            ) : null}
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'physician':
                extraProps.header = (
                    <HeaderData>
                        <DemiText>{t('scheduleSurgery.details.AccountPhysicianTemplate.Physician')}</DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: '0rem 2rem',
                    width: '25%',
                    textAlign: 'left',
                };
                extraProps.bodyStyle = {
                    textAlign: 'left',
                    width: '25%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems
                            marginBottom={'0px'}
                            marginTop={'20px'}
                            width={'100%'}
                            padding={'0rem 2rem'}
                            ipadPadding={'0.5rem 1.6rem 0.5rem 0.5rem'}
                            mdPadding={'0 2rem 0px'}
                            ldPadding={'0 2rem 0px'}
                            style={{
                                display: 'block',
                            }}
                        >
                            <Subtitle fontSize={'14px'}>
                                {rowData?.physicianName
                                    ? rowData.physicianName
                                    : 'NA'}
                            </Subtitle>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'procedureDetails':
                extraProps.header = (
                    <HeaderData>
                        <DemiText>{t('orders.orderDetails.procedureData.procedureDetails')}</DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: '0rem 2rem',
                    width: '25%',
                    textAlign: 'left',
                };
                extraProps.bodyStyle = {
                    textAlign: 'left',
                    width: '25%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems
                            marginBottom={'0px'}
                            marginTop={'20px'}
                            width={'100%'}
                            padding={'0rem 2rem'}
                            ipadPadding={'0.5rem 1.6rem 0.5rem 0.5rem'}
                            mdPadding={'0 2rem 0px'}
                            ldPadding={'0 2rem 0px'}
                            style={{
                                display: 'block',
                            }}
                        >
                            <Subtitle fontSize={'14px'}>
                                {rowData.procedureName}
                            </Subtitle>
                            {rowData.pediatricSurgery && (
                                <Subtitle fontSize={'14px'}>
                                    {t('common.pediatricProcedureLabel')}
                                </Subtitle>
                            )}
                            {rowData?.procedureDetails
                                ? rowData.procedureDetails?.map((x, idx) => {
                                      return (
                                          <Subtitle key={idx} fontSize={'14px'}>
                                              {x!=='PediatricSurgery'&&x}
                                          </Subtitle>
                                      );
                                  })
                                : null}
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'biologicsUsed':
                extraProps.header = (
                    <HeaderData>
                        <BackorderText>{t('orders.orderDetails.procedureData.biologicsUsed')}</BackorderText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: '0 2rem 0 30px',
                    width: '25%',
                    textAlign: 'left',
                };
                extraProps.bodyStyle = {
                    textAlign: 'left',
                    width: '25%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems
                            marginBottom={'0px'}
                            marginTop={'20px'}
                            width={'100%'}
                            padding={'0rem 2rem'}
                            ipadPadding={'0.5rem 1.7rem 0.5rem 0.5rem'}
                            mdPadding={'0 1.8rem 0px'}
                            ldPadding={'0rem 2rem'}
                        >
                            {rowData?.biologicsDetails ? (
                                rowData.biologicsDetails?.map((x, idx) => {
                                    return (
                                        <Subtitle key={idx} fontSize={'14px'}>
                                            {x}
                                        </Subtitle>
                                    );
                                })
                            ) : (
                                <Subtitle fontSize={'14px'}>{'NA'}</Subtitle>
                            )}
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });
     
    
        
    const openReportProcedureData = () => {
        setProcedureData({});
        dispatch(setPediatricCheck(''));
        const data = {
            procedureCode:
                 '',
            salesOrg: salesOrg,
        };
        dispatch(getProcedureInfoRequest('Equity',data));
        dispatch(
                    getConfigurations(
                        { resourceType: 'visibility', module: EQUITY },
                        REPORT_PROCEDURE_DATA
                    )
                );
        dispatch(
            setReportProcedureModalState({
                showReportProcedureModal: true,
            })
        );
        dispatch(
            setOrderSummaryModalState({
                myCaseRef: myCaseRef,
                orderSummaryModal: false,
            })
        );
    };
    const toggleProcedureCard = (ind) => {
        const clonedProcedureData = [...procedureDateLocal];
        clonedProcedureData[ind].openCard = !clonedProcedureData[ind].openCard;
        setProcedureData(clonedProcedureData);
    };
    return (
        <>
            <HeadContainer>
                <ProcedureDataTitle isCondensedView={isCondensedView} >
                    {t('orders.orderDetails.procedureData.ProcedureReports')}{' '}
                    {`(${procedureData?.length ? procedureData.length : 0})`}
                </ProcedureDataTitle>
                {procedureEquityPageVisibility&&<Button
                 id={'orders-orderdetails-proceduredata-reportproceduredata'}
                    show
                    width={isMobile ? '37%' : '25%'}
                    mobileWidth={'50%'}
                    height={isMobile ? '34px' : '38px'}
                    clicked={openReportProcedureData}
                    // padding={isMobile ? '0px 5px 0px 0px' : ''}
                    // border={'1px solid'}
                    //color={'#1010EB'}
                    margin={isMobile ? isCondensedView ? '0px 0px 10px 15px' : '0px 0px 10px 0px' : '4px 0px 4px 0px'}
                    fontSize={'13px'}
                    fontFamily={'AvenirNextWorld Demi'}
                    // border={'1px solid #ffffff '}
                    borderRadius={'25px'}
                    variant={ButtonStyles?.signatureBtnEnabled}
                >
                    {t('orders.orderDetails.procedureData.reportProcedureData')}
                </Button>}
            </HeadContainer>
            <Div>
                <Datatable
                    id={'orders-orderDetails-proceduredata-datatable'}
                    backgroundColorOdd={'#FFFFFF99'}
                    backgroundColorEven={'#F5F5F599'}
                    resizableColumns
                    columns={colData}
                    data={procedureData}
                    scrollable
                />
            </Div>
            <ProcedureDataMobileView
                dataToBeMapped={procedureDateLocal}
                toggleProcedureCard={toggleProcedureCard}
                ordersList={ordersList}
            />
        </>
    );
};

export default ProcedureData;
